import { defineMessages } from 'utils/intl';

export default defineMessages({
  mainHeader: 'Zaufało nam już ponad {clients} firm i instytucji publicznych',
  mainDescription: 'dla wielu z nich staliśmy się partnerem IT pierwszego wyboru',
  showMore: 'Pokaż więcej',
  showLess: 'Pokaż mniej',
});
